export interface MonthOption {
  value: number
  label: string
}

// Intl gives the case running text uses, which is lower in Swedish and Spanish
// ("januari", "enero"); a standalone label starts with a capital instead.
// toLocaleUpperCase leaves a caseless script such as Chinese ("1月") untouched,
// and follows the locale's own rules where they differ, as Turkish i/dotted I does.
const capitalizeFirstLetter = (value: string, locale: string): string =>
  value.replace(/^./u, first => first.toLocaleUpperCase(locale))

// Formatting in UTC keeps a UTC-constructed first-of-month from slipping back
// into the previous month for viewers west of Greenwich.
export const getMonthNames = (locale: string): string[] => {
  const { format } = new Intl.DateTimeFormat(locale, { month: 'long', timeZone: 'UTC' })

  return Array.from({ length: 12 }, (_, monthIndex) =>
    capitalizeFirstLetter(format(new Date(Date.UTC(2021, monthIndex, 1))), locale),
  )
}

export const getMonths = (locale = 'en'): MonthOption[] =>
  getMonthNames(locale).map((label, index) => ({ value: index + 1, label }))
